var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-form', {
    attrs: {
      "model": _vm.account,
      "label-width": "120px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "First name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "First name"
    },
    model: {
      value: _vm.account.first_name,
      callback: function ($$v) {
        _vm.$set(_vm.account, "first_name", $$v);
      },
      expression: "account.first_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Last name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Last name"
    },
    model: {
      value: _vm.account.last_name,
      callback: function ($$v) {
        _vm.$set(_vm.account, "last_name", $$v);
      },
      expression: "account.last_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.account.email,
      callback: function ($$v) {
        _vm.$set(_vm.account, "email", $$v);
      },
      expression: "account.email"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Phone number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "+972 544 123 456"
    },
    model: {
      value: _vm.account.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.account, "phone_number", $$v);
      },
      expression: "account.phone_number"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Slack username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "@alice"
    },
    model: {
      value: _vm.account.slack_username,
      callback: function ($$v) {
        _vm.$set(_vm.account, "slack_username", $$v);
      },
      expression: "account.slack_username"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "First day of week"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.account.first_day_of_week,
      callback: function ($$v) {
        _vm.$set(_vm.account, "first_day_of_week", $$v);
      },
      expression: "account.first_day_of_week"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "sunday",
      "label": "Sunday"
    }
  }), _c('el-option', {
    attrs: {
      "value": "monday",
      "label": "Monday"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Timezone"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: _vm.account.timezone,
      callback: function ($$v) {
        _vm.$set(_vm.account, "timezone", $$v);
      },
      expression: "account.timezone"
    }
  }, _vm._l(_vm.timezones, function (tz) {
    return _c('el-option', {
      key: tz,
      attrs: {
        "value": tz,
        "label": tz
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }